import { render } from "./HeroiconsSolidChartSquareBar.vue?vue&type=template&id=1c8c3d59"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChartSquareBar.vue"]])

export default __exports__